import { defineComponent as _defineComponent } from 'vue'
import ProfileInformationViewObject = Vertica.LouisPoulsen.Application.Content.Pages.PartnerPortal.MyProfile.ProfileInformationViewObject;
import MultiFactorAuthenticationViewObject = Vertica.LouisPoulsen.Application.Account.Api.Responses.MultiFactorAuthenticationViewObject;
import MfaEnable from '@/ui/views/mfa/MfaEnable.vue';
import { ref } from 'vue';
import { MfaType } from '@/enums';
import accountService from '@/services/account.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileInformation',
  props: {
    title: { default: '' },
    allowEdit: { type: Boolean },
    profileInformation: null,
    contactLabel: { default: '' },
    changePasswordLink: { default: '' },
    changePasswordLinkLabel: { default: '' },
    initialsLabel: { default: '' },
    userNameLabel: { default: '' },
    customerNumberLabel: { default: '' },
    emailLabel: { default: '' },
    customerLabel: { default: '' },
    submitButtonText: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: string, allowEdit: boolean, profileInformation: ProfileInformationViewObject, contactLabel: string, changePasswordLink: string, changePasswordLinkLabel: string, initialsLabel: string, userNameLabel: string, customerNumberLabel: string, emailLabel: string, customerLabel: string, submitButtonText: string }


const showSpinner = ref<boolean>(false);
const showMfaMessage = ref<boolean>(false);
const mfaRequestSuccess = ref<boolean>(false);

const mfaState = ref<MultiFactorAuthenticationViewObject>(null);

const selectedType = ref<string>('');

if (props.allowEdit) {
    loadMfaSettings();
} else {
    setMfaState(MfaType.None.toString());
}

async function loadMfaSettings() {
    const mfaSettings = await accountService.getMfaSettings();
    mfaState.value = mfaSettings;
}

function setMfaState(state: string) {
    mfaRequestSuccess.value = false;
    selectedType.value = state;
};

async function updateAccount() {
    showMfaMessage.value = false;
    mfaRequestSuccess.value = false;
    showSpinner.value = true;

    const success = await accountService.setMfaState(MfaType[selectedType.value]).finally(() => {
        showSpinner.value = false;
        showMfaMessage.value = true;
    });

    if (success) {
        mfaRequestSuccess.value = true;
    }
}


return { __sfc: true,props, showSpinner, showMfaMessage, mfaRequestSuccess, mfaState, selectedType, loadMfaSettings, setMfaState, updateAccount, MfaEnable }
}

})